Vue.component("MpMap", {
    props: {
        markerList: Array,
        country: String,
        reference: String,
        interactive: {
            type: Boolean,
            default: true
        },
        lat: [Number, String],
        lng: [Number, String],
        zoom: [String, Number],
        defaultMarker: String,
        type: String
    },
    data: function() {
        return {
            TYPE_SUCCESS: '',

            lang: '',

            latitude: null,
            longitude: null,
            zoomLevel: null,

            map: null,

            dataLocations: [],
        };
    },
    computed: {
        defaultURL: function() {
            return '/data/'+this.lang+'/contact.json';
        },
    },
    methods: {
        initMap: function() {
            this.map = new GoogleMap(this.$refs[this.reference], {
                lat: this.latitude,
                lng: this.longitude,
                zoom: this.zoomLevel,
                interactive: this.interactive
            });
            this.map.init();
            this.map.initMarkers(this.dataLocations);

            if (this.defaultMarker === 'true') {
                this.map.showMarker();
            }
        },

        addDataLocations: function() {
            this.dataLocations = clone(this.markerList);
            this.initMap();
        },

        onDataLoad: function(response) {
            if (response.status !== 200) {
                return;
            }

            // Process data.points to MapPoint format
            var i,
                points = response.data.points,
                pointTmp;

            this.latitude = response.data.default_latitud;
            this.longitude = response.data.default_longitud;
            this.zoomLevel = response.data.default_zoom;

            this.dataLocations = [];

            for (i=0; i<points.length; i++) {
                pointTmp = points[i];

                this.dataLocations.push(new MapPoint({
                    lat: pointTmp.latitude,
                    lng: pointTmp.longitude,
                    zoom: pointTmp.zoom,
                    name: pointTmp.name,
                    address: pointTmp.address,
                    zipcode: pointTmp.zipCode,
                    location: pointTmp.location,
                    province: pointTmp.province,
                    phone: pointTmp.telefono,
                    fax: pointTmp.fax,
                    email: pointTmp.email,
                    icon: pointTmp.icon,
                    iconWidth: pointTmp.icon_width,
                    iconHeight: pointTmp.icon_height,
                }));
            }

            this.initMap();
        },

        loadDataLocations: function() {
            if (this.markerList && Array.isArray(this.markerList)) {
                this.addDataLocations();
                return;
            }

            var requestURL = (this.src) ? this.src : this.defaultURL;

            axios
                .get(requestURL)
                .then(this.onDataLoad)
                .catch(function(error) {
                    console.log(error);
                });
        },

        init: function() {
            this.lang = this.country || 'es';
            this.latitude = this.lat;
            this.longitude = this.lng;
            this.zoomLevel = this.zoom;

            if (!this.reference) {
                console.error('❌ El mapa tiene que tener una referencia única en la página!!');
            }

            this.loadDataLocations();
        }
    },
    mounted: function() {
        this.init();
    },
    updated: function() {
    },
    template: '\
    <div class="map">\
        <div class="map__inner" :ref="reference"></div>\
    </div>',
});